import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    username: '',
    fullname: '',
    password: '',
    region: 'Corporate',
    branch: 'HO',
    struktur_unit: 'HR GA Dept',
    user_isdisabled: 0,
    detail_group: [
      { group_id: '0', group_name: 'Administrator', selected: false, rowid: 'group-0' },
      { group_id: '1', group_name: 'Operation Project', selected: false, rowid: 'group-1' },
      { group_id: '2', group_name: 'Marketing Project', selected: false, rowid: 'group-2' },
      { group_id: '3', group_name: 'Admin Logistik', selected: false, rowid: 'group-3' },
      { group_id: '10', group_name: 'Admin Branch Medan', selected: false, rowid: 'group-10' },
      { group_id: '11', group_name: 'HRD - GA', selected: false, rowid: 'group-11' },
      { group_id: '18', group_name: 'Admin St. Merapi', selected: false, rowid: 'group-18' },
      { group_id: '19', group_name: 'Tax Departement', selected: false, rowid: 'group-19' },
    ],
    detail_unfinished_pr: [],
    detail_log: [],
    user_createdby: '',
    user_createddate: '',
    user_modifyby: '',
    user_modifydate: '',
    rowid: '',
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
  unfinishedPrSelectedRowId: null,
};

const adm07userSlice = createSlice({
  name: 'adm07user',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    setUnfinishedPrSelectedRowId: (state, action) => { state.unfinishedPrSelectedRowId = action.payload; },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialState.formData, ...action.payload };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.unfinishedPrSelectedRowId = null;
      state.formData = initialState.formData;
    },
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  setDataList,
  setTotalData,
  setUnfinishedPrSelectedRowId,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  updateFormData,
  resetState,
  setActiveTab,
  clearModuleState,
} = adm07userSlice.actions;

export default adm07userSlice.reducer;
